import { makeStyles } from "@material-ui/core/styles";

const useNotificationsStyles = makeStyles(theme => ({
  section: {
    padding: theme.spacing(2),
  },
  sectionTitle: {
    fontSize: "24px",
    fontWeight: 700,
    fontHeight: "30px",
    color: "#FFFFFF",
  },
  infoText: {
    color: "white",
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1),
  },
  toggleContainerTop: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  toggleContainerBot: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  toggleContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  toggleContainerItem: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  fieldLabel: {
    fontSize: "1rem",
  },
  optionButtons: {
    display: "flex",
    gap: theme.spacing(1),
  },
  optionButton: {
    padding: theme.spacing(1),
    border: "1px solid #fff",
    borderRadius: theme.spacing(0.5),
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
  },
  active: {
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
  },
  saveButtonContainer: {
    marginTop: theme.spacing(2),
    textAlign: "right",
  },
  errorText: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1),
    color: "white",
  },
  notificationContainer: {
    padding: "18px",
    height: "670px",
    maxHeight: "670px",
    borderRadius: "16px",
    backgroundColor: "#131313",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    boxSizing: "border-box",
    [theme.breakpoints.up("sm")]: {
      height: "100vh",
      maxHeight: "100vh",
      padding: "24px",
      /** Панель зліва від краю екрана: лише ліві кути заокруглені */
      borderRadius: "12px 0 0 12px",
      backgroundColor: "#131313",
    },
    [theme.breakpoints.down("sm")]: {
      height: "100vh",
      maxHeight: "100vh",
      padding: "24px",
      borderRadius: 0,
      backgroundColor: "#131313",
    },
  },
  /** Рядок заголовка + кнопка закриття (мобілка) */
  notificationsHeaderRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(1),
    flexShrink: 0,
    marginBottom: "12px",
    width: "100%",
  },
  notificationsTitleInHeader: {
    marginBottom: "0 !important",
    flex: 1,
    minWidth: 0,
  },
  notificationsCloseButton: {
    flexShrink: 0,
    padding: theme.spacing(1),
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.08)",
    },
  },
  /** Заголовок панелі сповіщень (усі екрани) */
  desktopNotificationsTitle: {
    fontSize: "20px",
    fontWeight: 600,
    color: "#FFFFFF",
    marginBottom: "12px",
    flexShrink: 0,
  },
  listContainer: {
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    margin: "0 -18px",
    paddingBottom: "12px",
    overscrollBehavior: "contain",
    "& .MuiList-padding": {
      paddingTop: 0,
      paddingLeft: "18px",
      paddingRight: "18px",
    },
    [theme.breakpoints.up("sm")]: {
      margin: "0 -24px",
      "& .MuiList-padding": {
        paddingLeft: "24px",
        paddingRight: "24px",
      },
    },
    [theme.breakpoints.down("sm")]: {
      margin: "0 -24px",
      "& .MuiList-padding": {
        paddingLeft: "24px",
        paddingRight: "24px",
      },
    },
    "& .MuiListItem-dense": {
      paddingTop: "12px",
      paddingBottom: "12px",
    },
    // Custom scrollbar styles
    "&::-webkit-scrollbar": {
      width: "12px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#1F1F1F",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#FFD0E1",
      width: "8px",
      borderRadius: "6px",
      border: "2px solid #1F1F1F",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "#FFD0E1",
    },
    // Firefox scrollbar
    scrollbarWidth: "thin",
    scrollbarColor: "#FFD0E1 #1F1F1F",
  },
  sectionHeader: {
    color: "#FFFFFF",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: 1.1,
    marginTop: "18px",
    marginBottom: "10px",
    "&:first-child": {
      marginTop: 0,
    },
  },
  notificationItem: {
    borderBottom: "1px solid #1F1F1F",
    color: "white",
    paddingLeft: 0,
    paddingRight: 0,
    display: "flex",
    columnGap: "7px",
    rowGap: "10px",
  },
  pagination: {
    marginTop: theme.spacing(1),
    display: "flex",
    justifyContent: "space-between",
    padding: theme.spacing(1),
  },
  followButton: {
    display: "flex",
    border: "1px solid #FE5A97",
    color: "#FFFFFF",
    padding: theme.spacing(0.5, 2),
    textTransform: "none",
    fontWeight: 600,
    fontSize: "13px",
    whiteSpace: "nowrap",
    width: "80px",
    backgroundColor: "#FE5A97",
    borderRadius: "8px",
    [theme.breakpoints.down("sm")]: {
      padding: "6px 12px",
      fontSize: "12px",
      justifyContent: "center",
    },
  },

  acceptButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid #FE5A97",
    backgroundColor: "#1F1F1F",
    color: "#FFFFFF",
    width: 39,
    height: 32.5,
    minWidth: 39,
    minHeight: 32.5,
    padding: 0,
    borderRadius: "8px",
    "& svg": {
      display: "block",
      width: 17,
      height: 17,
    },
    [theme.breakpoints.down("sm")]: {
      padding: "6px 12px",
      fontSize: "12px",
      justifyContent: "center",
    },
  },
  verifiedIcon: {
    color: "#FE5A97",
    width: "12px",
  },

  avatar: {
    width: 44,
    height: 44,
    cursor: "pointer",
  },
  pendingRequestsToggleButton: {
    backgroundColor: "transparent",
    border: "1px solid #FF68D5",
    color: "#FF68D5",
    textTransform: "none",
    fontWeight: 600,
    fontSize: "13px",
    padding: "6px 16px",
    borderRadius: "8px",
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: "#FE5A97",
      color: "#FFFFFF",
    },
    "&:focus": {
      outline: "none",
      boxShadow: "none",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
      padding: "5px 12px",
    },
  },
  tabWrapper: {
    borderRadius: "8px",
    color: "#FF68D5",
    minHeight: "40px",
    maxHeight: "40px",
    flexShrink: 0,
    overflow: "hidden",
    backgroundColor: "#1F1F1F",
    display: "flex",
    "& .MuiTabs-root": {
      width: "100%",
    },
    "& .MuiTabs-flexContainer": {
      gap: "2px",
      display: "flex",
      width: "100%",
    },
  },
  tab: {
    color: "white",
    fontWeight: 600,
    fontSize: "14px",
    flex: 1,
    height: "35px",
    minHeight: "40px",
    maxHeight: "40px",
    backgroundColor: "#1F1F1F",
    borderRadius: "0",
    marginRight: 0,
    "&:first-child": {
      borderRadius: "8px 0 0 8px",
    },
    "&:last-child": {
      borderRadius: "0 8px 8px 0",
    },
    "& .MuiTab-wrapper": {
      color: "white",
    },
    "&:focus": {
      outline: "none",
    },
    "&.Mui-focusVisible": {
      outline: "none",
      border: "none",
    },
  },
  activeTab: {
    color: "white !important",
    backgroundColor: "#FE5A97",
    fontWeight: "bold",
    borderRadius: "8px !important",
    minHeight: "40px",
    maxHeight: "40px",
    "&:first-child": {
      borderRadius: "8px !important",
    },
    "&:last-child": {
      borderRadius: "8px !important",
    },
    "& .MuiTab-wrapper": {
      color: "white",
    },
    "&:focus": {
      outline: "none",
    },
    "&.Mui-focusVisible": {
      outline: "none",
      border: "none",
    },
  },
  headline: {
    fontSize: "13px",
    fontWeight: 700,
    color: "#FFFFFF",
    lineHeight: 1.2,
  },
  body: {
    fontSize: "13px",
    fontWeight: 400,
    color: "#FFFFFF",
    lineHeight: 1.4,
  },
  videoRequestModal: {
    "& .MuiDialog-paper": {
      backgroundColor: "#131313",
      borderRadius: "12px",
      padding: "40px",
      maxWidth: "550px",
      width: "100%",
      [theme.breakpoints.down("sm")]: {
        padding: "20px 15px",
      },
    },
  },
  videoRequestLabel: {
    fontSize: "20px",
    fontWeight: 600,
    color: "#FFFFFF",
    marginBottom: "12px",
    display: "block",
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
      fontWeight: 700,
    },
  },
  videoRequestInputField: {
    width: "100%",
    marginBottom: "24px",
    backgroundColor: "#1F1F1F",
    borderRadius: "8px",
    padding: "12px 16px",
    color: "#FFFFFF",
    fontSize: "13px",
    "&::before": {
      display: "none",
    },
    "&::after": {
      display: "none",
    },
    "& input": {
      color: "#FFFFFF",
      "&::placeholder": {
        color: "#FFFFFFCC",
        opacity: 1,
      },
    },
    "&.Mui-disabled": {
      color: "#FFFFFF",
      "& input": {
        color: "#FFFFFF",
      },
    },
  },
  videoRequestUploadButton: {
    backgroundColor: "#FE5A97",
    border: "1px solid #FE5A97",
    color: "#FFFFFF",
    textTransform: "none",
    fontSize: "13px",
    fontWeight: 600,
    padding: "12px 20px",
    borderRadius: "8px",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      backgroundColor: "#FF6BA8",
      borderColor: "#FF6BA8",
    },
    "&:disabled": {
      backgroundColor: "#1F1F1F",
      borderColor: "#1F1F1F",
      color: "#A3A3A3",
    },
  },
  videoRequestRejectButton: {
    backgroundColor: "transparent",
    border: "1px solid #FE5A97",
    color: "#FE5A97",
    textTransform: "none",
    fontSize: "13px",
    fontWeight: 600,
    padding: "12px 20px",
    borderRadius: "8px",
    width: "100%",
    "&:hover": {
      backgroundColor: "#FE5A97",
      color: "#FFFFFF",
    },
  },
  videoFileInput: {
    display: "none",
  },
  rejectSuccessTitle: {
    fontSize: "32px",
    fontWeight: 700,
    color: "#FFFFFF",
    textAlign: "center",
    marginBottom: "16px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px",
    },
  },
  rejectSuccessMessage: {
    fontSize: "16px",
    fontWeight: 400,
    color: "#FFFFFFE5",
    textAlign: "center",
    marginBottom: "32px",
    lineHeight: 1.5,
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
}));

export default useNotificationsStyles;

